module.exports = __webpack_public_path__ + "static/wpf-87027928f11310d5480a93fb4fdd1748.jpg";